<svelte:options immutable={true} />

<script>
    import { CARD_SUITS, isFaceCard } from './deck'
    export let card
    export let show = false

    $: display = isFaceCard(card) ? card.value[0] : card.value
    $: isRedCard = card.suit === CARD_SUITS.HEARTS || card.suit === CARD_SUITS.DIAMONDS
    $: suitImageSource = `img/${card.suit}.svg`
</script>

<div class="card-wrapper" class:show={show}>
    <div class="card {isRedCard ? 'red' : 'black'}">
        <div class="value top left">
            <div>{display}</div> 
            <img src="{suitImageSource}" alt="{card.suit[0].toUpperCase()}"/>
        </div>
        <div class="value top right">
            <div>{display}</div> 
            <img src="{suitImageSource}" alt="{card.suit[0].toUpperCase()}"/>
        </div>
        <div class="value bottom left">
            <div>{display}</div> 
            <img src="{suitImageSource}" alt="{card.suit[0].toUpperCase()}"/>
        </div>
        <div class="value bottom right">
            <div>{display}</div> 
            <img src="{suitImageSource}" alt="{card.suit[0].toUpperCase()}"/>
        </div>
    </div>

    <div class="cardback">

    </div>
</div>

<style lang="scss">
    .card-wrapper {
        overflow: hidden;
        
        &:last-child {
            overflow: visible;
            z-index: 1;
        }

        &:not(.show) {
            .card {
                transform: scale(0, 1);
            }
        }

        &.show {
            .card {
                animation: flip 0.5s;
            }
        }
    }

    .card {
        display: inline-block;
        width: 16vmin;
        height: 24vmin;
        border: 1px solid #ddd;
        border-radius: 4px;
        background: white;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

        &.black { color: black; }
        &.red { color: red; }
    }

    .value {
        $corner-margin: 10px;

        position: absolute;
        text-align: center;
        text-transform: uppercase;
        font-size: 3vmin;

        &.left { left: $corner-margin; }
        &.right { right: $corner-margin; }
        &.top { top: $corner-margin; }
        &.bottom {
            transform: scale(-1, -1);
            bottom: $corner-margin;
        }

        img {
            width: 2vmin;
            height: 2vmin;
            margin: 2px;
        }
    }

    @keyframes flip {
		from { width: 0; transform: scale(0, 1) }
		to { transform: scale(1, 1) }
	}
</style>
